import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { device } from '../../../../constants';

type ImageProps = {
  src: string;
  alt: string;
};

const ResultScreenshot = ({ src, alt }: ImageProps) => {
  const [isLoaded, setIsLoaded] = useState(false);

  const handleImageLoad = () => {
    setIsLoaded(true);
  };
  useEffect(() => {
    const img = new Image();
    img.src = src;
    if (img.complete) {
      setIsLoaded(true);
    } else {
      img.onload = () => setIsLoaded(true);
    }
  }, [src]);
  return (
    <>
      {!isLoaded ? (
        <Skeleton />
      ) : (
        <StyledImage
          draggable={false}
          src={src}
          alt={alt}
          onLoad={handleImageLoad}
        />
      )}
    </>
  );
};

const StyledImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 10px;
`;
const Skeleton = styled.div`
  height: 100%;
  width: 100%;
  background-color: #000;
  animation: skeleton-loading 1.2s infinite;
  border-radius: 4px;
  @media screen and ${device.sm} {
    max-width: 150px;
    margin: 0 auto;
  }
  @keyframes skeleton-loading {
    0% {
      background-color: #e0e0e0;
    }
    50% {
      background-color: #f0f0f0;
    }
    100% {
      background-color: #e0e0e0;
    }
  }
`;
export default ResultScreenshot;
